import type React from 'react';
import Translation from '../../../general/Translation/Translation';
import ButtonStack from '../../../general/Button/ButtonStack';
import Section from '../../../general/Section/Section';
import Button from '../../../general/Button/Button';
import { useWithSiteUrl } from '../../../general/WebshopContext/WebshopContext';

const EmptyCart: React.FC = () => {
    const withSiteUrl = useWithSiteUrl();

    return (
        <Section>
            <div className="page-heading is-centered">
                <h1><Translation pageString="checkout" stringId="shoppingcart-title" /></h1>
                <p><Translation pageString="checkout" stringId="cart-empty-header" /></p>
                <ButtonStack isSm isRow>
                    <Button
                        isGhost
                        href={withSiteUrl('')}
                    >
                        <Translation pageString="checkout" stringId="continue-shopping" />
                    </Button>
                </ButtonStack>
            </div>
        </Section>
    );
};

export default EmptyCart;
